import React from "react";

import { NavLink } from "react-router-dom";
import {
  Typography,
  ListItem,
  ListItemIcon,
  DrawerProps,
  Grid,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { MenuItem } from "./SideMenuData";

export type SideMenuItemProps = Omit<MenuItem, "display"> & {
  onNavigation?: DrawerProps["onClose"] | any;
};

const useStyles = makeStyles()((theme) => ({
  outerContainer: {
    padding: 0,
    height: theme.spacing(3),
    margin: theme.spacing(3, 0),
  },
  itemContainer: {
    alignItems: "center",
    borderRadius: "18px",
    display: "flex",
    flex: 1,
    padding: theme.spacing(2, 3),
    textDecoration: "none",
  },
  itemContainerActive: {
    backgroundColor: theme.palette.primary.main,
    "& div.MuiListItemIcon-root, & > span": {
      color: theme.palette.common.white,
    },
  },
  iconContainer: {
    color: theme.palette.text.primary,
    marginRight: theme.spacing(1),
    height: "30px",
    width: "30px",
  },
}));

export const SideMenuItem = ({
  title,
  Icon,
  navigateTo,
  onNavigation,
}: SideMenuItemProps) => {
  const { classes } = useStyles();
  return (
    <ListItem className={classes.outerContainer} key={title}>
      <NavLink
        className={classes.itemContainer}
        to={navigateTo}
        activeClassName={classes.itemContainerActive}
        onClick={onNavigation}
      >
        <Grid
          item
          container
          alignItems="center"
          justifyContent="center"
          className={classes.iconContainer}
        >
          {Icon && (
            <ListItemIcon sx={{ minWidth: 0, color: "inherit" }}>
              {/* @ts-expect-error MUI's SVGs are not typed properly */}
              <Icon sx={{ color: "inherit" }} />
            </ListItemIcon>
          )}
        </Grid>
        <Typography variant="body1" component="span" color="text.primary">
          {title}
        </Typography>
      </NavLink>
    </ListItem>
  );
};
